import { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import { makeStyles } from "@material-ui/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
function InputField(props) {
    const { name, id = name, value = '', multiline = false, rows = 0, handleOnChange = null, isCompulsory = false, label, inputProps, disabled, showClearIcon=true, ...rest } = props;
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        if (value !== inputValue) {
            setInputValue(value);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value])
    const labelTxt =
        isCompulsory ? (
            <span>
                {label}
                <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
            </span>
        ) : (
            label
        );

    const handleInputOnChange = (e) => {
        let newVal = e.target.value;
        setInputValue(newVal);
        if (handleOnChange) {
            handleOnChange(e, newVal)
        }
    }

    const clearInput = (e) => {
        setInputValue('');
        if (handleOnChange) {
            handleOnChange(e)
        }else if(props.onBlur){
           props.onBlur(e)
        }
    }

    const useStyles = makeStyles({
        root: {
            "& .MuiOutlinedInput-root": {
                borderRadius: "6px",
                color: "#000",
            },
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                border: "1px solid",
                borderColor: "#A6A8AB",
            },
            "& .MuiInputLabel-outlined": {
                color: "#000",
                fontSize: "14px",
                fontWeight: "500",
                letterSpacing: ".03rem",
                marginTop: "3px"
            },
            "& .MuiFormLabel-filled": {
                color: "#666",
                fontSize: "15px",
                fontWeight: "500",
                letterSpacing: ".03rem",
            },
            "&:hover": {
                borderColor: "#A6A8AB",
            },
            "& .MuiInputLabel-outlined.Mui-focused": {
                color: "#0086ff",
                fontSize: "15px",
            },
            "& input": {
                padding: "9px 14px",
                height: "1.6em",
            },
            "& input::placeholder": {
                color: "#666",
                fontSize: "12px",
            },
            '& input[type=number]': {
                '-moz-appearance': 'textfield',
                padding: '9px 9px'
            },
            '& input[type=number]::-webkit-outer-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            '& input[type=number]::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            "& .MuiInputAdornment-root .cross--icon": {
                position: "relative",
                backgroundColor: "#fff",
                borderRadius: "50%",
                width: "25px",
                height: "25px",
                "&:hover": {
                    backgroundColor: "#f1f1f1",
                },
            },
            "& .cross": {
                position: "absolute",
                top: "3px",
                left: "7px",
                color: "#777",
                fontWeight: "600",
                height: "1.2em",
                cursor: "pointer",
            },
            "& .MuiInputBase-root.Mui-disabled, .MuiOutlinedInput-input.Mui-disabled": {
                backgroundColor: "#f0ebeb",
                color: "rgba(0, 0, 0, 1) !important", 
                paddingRight: '4px'
            },
            "& .MuiFormLabel-root.Mui-disabled.MuiFormLabel-filled": {
                color: "#000000 !important"
            }
        },
    });
    const classes = useStyles();
    return (
        <div>
            <TextField
                fullWidth
                disabled={disabled}
                id={id}
                label={labelTxt}
                multiline={multiline}
                rows={rows}
                value={inputValue}
                className={classes.root}
                onChange={handleInputOnChange}
                InputProps={{
                    ...inputProps,
                    autoComplete: "off",
                    endAdornment:
                       showClearIcon && !disabled && <InputAdornment position="end">
                            {inputValue.length > 0 && <div className="cross--icon"><FontAwesomeIcon icon={faXmark} className="cross" onClick={clearInput} /> </div>}
                        </InputAdornment>
                }
                }
                size={"small"}
                {...rest}
            />
        </div>
    );
}

export default InputField;